<template>
  <div class="sky-hc-left-nav">
    <div class="sky-hc-left-nav__search-box" v-if="hasSearch">
      <el-input
        class="sky-hc-left-nav__search-input"
        :placeholder="$t('help.searchPlacehoder2')"
        :class="
          isSearchActive || (kewordList.length && !hideKeywordList) ? 'sky-hc-left-nav__search-input--active' : ''
        "
        @focus="handleInputMouserover"
        @blur="handleInputMouseOut"
        v-model="keyword"
        @input="handleSearchChange"
        @keyup.native.enter="handleSearch"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          class="sky-hc-left-nav__search-btn"
          @click.native="handleSearch"
        ></el-button>
      </el-input>
      <div class="sky-hc-left-nav__search-result" v-if="kewordList.length && !hideKeywordList">
        <div class="sky-hc-left-nav__search-split"></div>
        <ul class="sky-hc-left-nav__result-list">
          <li
            class="sky-hc-left-nav__result-item"
            v-for="(item, index) in kewordList"
            :key="index"
            @click="handleKeywordClick"
          >
            <tooltip-over
              class="sky-hc-left-nav__result-item-txt"
              :content="item.title"
              placement="right-end"
              refName="searchCon"
            >
            </tooltip-over>
          </li>
        </ul>
      </div>
    </div>
    <ul class="sky-hc-left-nav__list">
      <li class="sky-hc-left-nav__item" v-for="item in data" :key="item.categoryId" @click="handleGotoInnerPage(item)">
        <i
          class="sky-hc-left-nav__item--circle"
          conversionForbiddenPx2Rem="width,height"
          style="width:4px;height:4px"
        />
        {{ item.categoryName }}
      </li>
    </ul>
  </div>
</template>
<script>
import { Input, Tooltip, Button } from 'element-ui'

import { getSearchSuggest } from '@/api/help'
import TooltipOver from '@/components/tooltipOver'

import { CATEGORY_TYPE } from '@/utils/enum'
export default {
  name: 'LeftNav',
  components: {
    [Input.name]: Input,
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
    TooltipOver
  },
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    hasSearch: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  data() {
    return {
      isSearchActive: false,
      hideKeywordList: true,
      keyword: '',
      kewordList: [],
      timer: null
    }
  },
  created() {
    const _this = this
    document.documentElement.addEventListener('click', function(e) {
      if (!_this.hideKeywordList && e.target.className !== 'el-input__inner') {
        _this.hideKeywordList = true
      }
    })
  },
  methods: {
    handleSearchChange() {
      this.hideKeywordList = false
      this.timer && clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.handleGetSearchSuggest()
        this.timer && clearTimeout(this.timer)
      }, 100)
    },
    handleInputMouserover() {
      this.isSearchActive = true
    },
    handleInputMouseOut() {
      this.isSearchActive = false
    },
    handleGetSearchSuggest() {
      getSearchSuggest({
        searchKeyword: this.keyword,
        limit: 20
      }).then(response => {
        this.kewordList = response.data.content.itemArr
      })
    },
    handleKeywordClick(title) {
      this.keyword = title
      this.handleSearch()
    },
    handleSearch() {
      this.$router.push({
        path: `/help/search?keyword=${this.keyword}`
      })
    },
    handleGotoInnerPage(item) {
      this.$router.push({
        path: `/help/content?categoryId=${item.categoryId}&categoryName=${item.categoryName}&type=${CATEGORY_TYPE.ARTICLE}`
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-left-nav) {
  @include e(list) {
    padding-left: 16px;
  }
  @include e(item) {
    // list-style-type: disc;
    color: $--color-grey-8;
    line-height: 19px;
    margin-bottom: 20px;
    cursor: pointer;
    font-size: $--size-base;
    font-weight: bold;
    position: relative;
    @include m(circle) {
      content: '';
      display: block;
      width: 4px;
      height: 4px;
      margin-top: -1.5px;
      position: absolute;
      left: -14px;
      top: 50%;
      background-image: image-set(
        url('../../../assets/styles/css_images/help/round2.png') 1x,
        url('../../../assets/styles/css_images/help/round2@2x.png') 2x
      );
      background-size: 100% 100%;
    }
  }
  @include e(search-input) {
  }
  @include e(search-btn) {
    width: 44px;
    height: 32px;
  }
  @include e(search-box) {
    position: relative;
    width: fit-content;
    margin-bottom: 23px;
  }
  @include e(search-result) {
    box-sizing: border-box;
    padding: 0px 16px 10px;
    border: 1px solid $--color-primary;
    border-top: 0px;
    width: 100%;
    position: absolute;
    background: #fff;
    left: 0px;
    top: 31px;
    z-index: 2;
    border-radius: 0 0 4px 4px;
  }
  @include e(result-item) {
    font-size: $--size-base;
    color: $--color-grey-7;
    line-height: 16px;
    cursor: pointer;
    &:hover {
      background: $--color-grey-2;
    }
  }
  @include e(result-item-txt) {
    width: 100%;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
  }
  @include e(search-split) {
    width: 100%;
    height: 1px;
    margin-bottom: 6px;
    background: $--color-grey-4;
  }
}
</style>
<style lang="scss">
.sky-hc-left-nav__search-input {
  width: 212px;
  .el-input__inner {
    width: 168px;
    height: 32px;
    border-right: 0px;
    box-sizing: border-box;
    border-radius: 2px 0 0 0;
    &:hover {
      border-color: $--color-grey-4;
    }
  }
  .el-input-group__append {
    background: #fff;
  }
}
.sky-hc-left-nav__search-input--active {
  .el-input__inner {
    border-color: $--color-primary !important;
  }
  .el-input-group__append {
    border-color: $--color-primary;
  }
}
</style>
